<template>
    <v-row no-gutters justify="center">
        <v-col cols="3">
            <v-card color="transparent" flat>
                <v-list-item>
                    <v-list-item-avatar><v-img alt="available" contain src="@/assets/container-blue.png" width="16"></v-img></v-list-item-avatar>
                    <v-list-item-content><span class="text-uppercase text-caption">Endorser</span></v-list-item-content>
                </v-list-item>
            </v-card>                                            
        </v-col>
        <v-col cols="3">
            <v-card color="transparent" flat>
                <v-list-item>
                    <v-list-item-avatar><v-img alt="available" contain src="@/assets/container-purple.png" width="16"></v-img></v-list-item-avatar>
                    <v-list-item-content><span class="text-uppercase text-caption">Orderer</span></v-list-item-content>
                </v-list-item>
            </v-card>                                            
        </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'TopologyLegend',
    data: () => ({
    }),
  }
</script>
